export enum TalentProfileCollaboratorInvitationStatus {
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  ACCEPTED = 'ACCEPTED'
}

export interface InviteCollaboratorRequest {
  email: string
}

export type CancelInviteCollaboratorRequest = InviteCollaboratorRequest

export interface RevokeInviteCollaboratorRequest {
  userId: number
  email: string
}
export interface ResendInviteCollaboratorRequest {
  id: string
  email: string
}

export interface AcceptCollaboratorInvitationRequest {
  email: string
  token: string
  firstName: string
  lastName: string
  country: string
  password: string
}

export interface TalentCollaborator {
  id?: string
  email?: string
  status?: TalentProfileCollaboratorInvitationStatus
  talentProfileCollaborator?: {
    createdAt?: string
    updatedAt?: string
    id?: string
    permissions?: any
  }
  user?: {
    avatar: string
    email: string
    firstName: string
    lastName: string
    id: string
  }
  inviteLink?: string
}

export interface CollaboratorProfile {
  id: string
  talentProfile: {
    id: string
    avatar: string
    displayName: string
    firstName: string
    lastName: string
    user?: {
      id: number
      username: string
    }
  }
}
